import React from 'react';
import {Slider as OriginalSlider} from '@material-ui/core';
import styles from "./Slider.module.scss";

interface ISliderProps {
  min?: number;
  max?: number;
  value?: number;
  onChange?: (value?: number) => void;
  valueLabelDisplay?: string;
  'aria-label'?: string;
}

const Slider = (props) => (<OriginalSlider className={styles.Slider}  {...props} />);

Slider.defaultProps = {
  min: 0,
  max: 9999,
  value: 0,
  valueLabelDisplay: 'on',
  'aria-label': 'price slider',

};

export default Slider;
